import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OrganizationsTab } from '@/components/Administrator/Organizations/OrganizationsTab';
import { UsersTab } from '@/components/Administrator/Users/UsersTab';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ROLE } from '../../common/role';
import { usePermission } from '../../hooks/use-permission';

export function Administration() {
	const { t } = useTranslation();
	const hasOrgPermission = usePermission(ROLE.ORGANIZATION_READ);
	const [activeTab, setActiveTab] = useState<string>(hasOrgPermission ? 'organizations' : 'users');
	useEffect(() => {
		setActiveTab(hasOrgPermission ? 'organizations' : 'users');
	}, [hasOrgPermission]);
	return (
		<div className="h-[calc(100vh-64px)] w-full flex flex-col bg-background">
			<div className="flex-1 overflow-hidden">
				<Tabs
					value={activeTab}
					onValueChange={setActiveTab}
					className="h-full bg-card text-card-foreground gap-0"
				>
					<TabsList className="justify-start rounded-none border-b border-transparent bg-transparent p-0">
						<TabsTrigger
							value="organizations"
							className="rounded-none border-0 border-b-2 border-transparent data-[state=active]:border-primary! data-[state=active]:bg-transparent data-[state=active]:text-primary! bg-transparent! text-muted-foreground hover:text-primary! hover:cursor-pointer px-4 py-2"
							hidden={!hasOrgPermission}
						>
							{t('admin.tabs.organizations')}
						</TabsTrigger>
						<TabsTrigger
							value="users"
							className="rounded-none border-0 border-b-2 border-transparent data-[state=active]:border-primary! data-[state=active]:bg-transparent data-[state=active]:text-primary! bg-transparent! text-muted-foreground hover:text-primary! hover:cursor-pointer px-4 py-2"
						>
							{t('admin.tabs.users')}
						</TabsTrigger>
					</TabsList>

					<TabsContent value="organizations" className="flex-1 overflow-auto m-0 p-6 bg-background text-foreground">
						<OrganizationsTab />
					</TabsContent>

					<TabsContent value="users" className="flex-1 overflow-auto m-0 p-6 bg-background text-foreground">
						<UsersTab />
					</TabsContent>
				</Tabs>
			</div>
		</div>
	);
}
